/**
 * @generated SignedSource<<ca47969cd2178ee176d482232233ebef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddonOperationResultType = "ADDON_NOT_FOUND" | "DEVELOPMENT_STORE_ERROR" | "GENERIC_ERROR" | "NO_PREMIUM" | "SUCCESS";
export type sharedRemoveAddOnMutation$variables = {
  addonId: number;
};
export type sharedRemoveAddOnMutation$data = {
  readonly removeAddon: AddonOperationResultType;
};
export type sharedRemoveAddOnMutation = {
  response: sharedRemoveAddOnMutation$data;
  variables: sharedRemoveAddOnMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "addonId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "addonId",
        "variableName": "addonId"
      }
    ],
    "kind": "ScalarField",
    "name": "removeAddon",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedRemoveAddOnMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sharedRemoveAddOnMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "eb4c60e97561fc88e0a33ac1ef3d72de",
    "id": null,
    "metadata": {},
    "name": "sharedRemoveAddOnMutation",
    "operationKind": "mutation",
    "text": "mutation sharedRemoveAddOnMutation(\n  $addonId: Long!\n) {\n  removeAddon(addonId: $addonId)\n}\n"
  }
};
})();

(node as any).hash = "3c32e716710bb13e07fdbe43dd60fc8a";

export default node;
